<script>
  import { t } from 'svelte-i18n';
  import ModalSection from './modal-section.svelte';
  import Footer from './footer.svelte';
</script>

<ModalSection first="true" desktopImg="true">
  <div slot="text">
    <h1 class="pb-0 text-wellabe-primary">wellabe</h1>
    <h1 class="pt-0">{$t('MODAL.WELLABE.TITLE')}</h1>
  </div>
  <p class="text-opaque-black" slot="padding">
    {$t('MODAL.WELLABE.DESCRIPTION')}
  </p>
  <div
    slot="img"
    style="background-image: url('images/wellabe-full-img.png'); background-position: top left;"
    class="bg-right bg-cover bg-no-repeat w-full sm:min-w-[486px] min-h-full h-auto ml-14 sm:ml-[4.5rem] md:ml-[8rem] md2:ml-0"
  />
</ModalSection>

<ModalSection app="wellabe" bgDark="true" inverse="true">
  <div slot="text">
    <h1>{$t('MODAL.WELLABE.TITLE2')}</h1>
    <p class="text-opaque-black">
      {@html $t('MODAL.WELLABE.DESCRIPTION2')}
    </p>
  </div>
  <img
    slot="img"
    alt="wellabe screen on a mobile device"
    src="images/wellabe-img2.png"
    class="img-mob"
  />
</ModalSection>

<ModalSection centeredImg="true">
  <div slot="text">
    <h1>{$t('MODAL.WELLABE.TITLE3')}</h1>
    <p class="text-opaque-black">
      {@html $t('MODAL.WELLABE.DESCRIPTION3')}
    </p>
    <p class="text-opaque-black mt-6">
      {$t('MODAL.WELLABE.DESCRIPTION4')}
    </p>
  </div>
  <img
    slot="img"
    alt="wellabe teleconsultation on a browser view"
    src="images/wellabe-img3.png"
    class="img-desk"
  />
</ModalSection>
<Footer />

<style>
  p {
    @apply py-0;
  }
  .img-mob {
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.35));
  }
  .img-desk {
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.15));
  }
</style>
